import React from 'react';
import { Container } from 'react-bootstrap';
import Particle from '../Particle';

function SectionLayout({ 
  className, 
  showParticles = true, 
  children,
  fluid = true,
  id,
}) {
  return (
    <Container fluid={fluid} className={className} id={id}>
      {showParticles && <Particle />}
      <Container>
        {children}
      </Container>
    </Container>
  );
}

export default SectionLayout;